import React from 'react';
import { formatMoneyLegacy } from '../../utils/currency';
import getDeparturePricingBreakdown from '../../utils/getDeparturePricingBreakdown';

function money(amount, currencyCode) {
	return formatMoneyLegacy(amount, currencyCode);
}

/**
 * Trip total, deposit today, and balance due after the group confirms.
 */
export default function DeparturePricingSummary({
	departure,
	travellerCount = 1,
	compact = false,
	className = '',
}) {
	const breakdown = getDeparturePricingBreakdown(departure, travellerCount);
	if (!breakdown) return null;

	const { currencyCode, perPerson, totals, travellerCount: count } = breakdown;
	const depositLabel = perPerson.depositPercent != null
		? `Reserve today (${perPerson.depositPercent}%)`
		: 'Reserve today (deposit)';

	if (compact) {
		return (
			<div className={`departure-pricing departure-pricing--compact ${className}`.trim()}>
				<p className="departure-pricing__compact-line">
					<span>Trip price</span>
					<strong>{money(perPerson.total, currencyCode)}</strong>
					<span className="departure-pricing__per">/ person</span>
				</p>
				<p className="departure-pricing__compact-line departure-pricing__compact-line--deposit">
					<span>{depositLabel}</span>
					<strong>{money(perPerson.deposit, currencyCode)}</strong>
				</p>
				<p className="departure-pricing__compact-note">
					Balance {money(perPerson.balance, currencyCode)} due after the group is confirmed.
				</p>
			</div>
		);
	}

	return (
		<div className={`departure-pricing ${className}`.trim()} aria-label="Pricing breakdown">
			<h3 className="departure-pricing__title">Pricing</h3>
			<p className="departure-pricing__lead">Per person · all amounts in {currencyCode}</p>

			<dl className="departure-pricing__rows">
				<div className="departure-pricing__row">
					<dt>Trip price</dt>
					<dd>{money(perPerson.total, currencyCode)}</dd>
				</div>
				<div className="departure-pricing__row departure-pricing__row--highlight">
					<dt>{depositLabel}</dt>
					<dd>{money(perPerson.deposit, currencyCode)}</dd>
				</div>
				<div className="departure-pricing__row">
					<dt>Balance after confirmation</dt>
					<dd>{money(perPerson.balance, currencyCode)}</dd>
				</div>
			</dl>

			{count > 1 && (
				<div className="departure-pricing__group">
					<p className="departure-pricing__group-label">For {count} travellers</p>
					<dl className="departure-pricing__rows departure-pricing__rows--group">
						<div className="departure-pricing__row">
							<dt>Total trip</dt>
							<dd>{money(totals.total, currencyCode)}</dd>
						</div>
						<div className="departure-pricing__row departure-pricing__row--highlight">
							<dt>Deposit today</dt>
							<dd>{money(totals.deposit, currencyCode)}</dd>
						</div>
						<div className="departure-pricing__row">
							<dt>Balance later</dt>
							<dd>{money(totals.balance, currencyCode)}</dd>
						</div>
					</dl>
				</div>
			)}

			<p className="departure-pricing__footnote">
				You pay the deposit now to hold your seat. The remaining balance is due once VisitAllNepal confirms the departure and assigns your operator.
			</p>
		</div>
	);
}
